import { APIEndpoints } from '@/data/constants/endpoints';
import { Request } from '@/data/api/utils/network';
import { RequestParams } from '@/data/types';
import { 
  TDeveloperListResponse, 
  TCasOrganizationListResponse, 
  TCasFeatureListResponse,
  TDeveloperUser,
  TCasOrganizationRow
} from '@/data/types/cas';

export const fetchDevelopers = async (params: RequestParams = {}) => {
  return Request({ path: APIEndpoints.CAS.ADMINS, type: 'GET', params }) as Promise<TDeveloperListResponse>;
};

export const addDeveloper = async (email: string) => {
  return Request({ path: APIEndpoints.CAS.ADMINS, type: 'POST', body: { email } });
};

export const removeDeveloper = async (id: string) => {
  return Request({ path: APIEndpoints.CAS.ADMIN_BY_ID(id), type: 'DELETE' });
};

export const fetchOrganizations = async (params: RequestParams = {}) => {
  return Request({ path: APIEndpoints.CAS.ORGANIZATIONS, type: 'GET', params }) as Promise<TCasOrganizationListResponse>;
};

export const fetchOrganizationDetails = async (id: string) => {
  return Request({ path: APIEndpoints.CAS.ORGANIZATION_BY_ID(id), type: 'GET' }) as Promise<any>;
};

export const fetchOrganizationPlan = async (id: string) => {
  return Request({ path: APIEndpoints.CAS.ORGANIZATION_PLAN(id), type: 'GET' }) as Promise<any>;
};

export const updateOrganizationFeatures = async (id: string, features: Record<string, boolean>) => {
  return Request({ path: APIEndpoints.CAS.ORGANIZATION_FEATURES(id), type: 'PATCH', body: { features } });
};

export const fetchAvailableFeatures = async () => {
  return Request({ path: APIEndpoints.CAS.FEATURES, type: 'GET' }) as Promise<TCasFeatureListResponse>;
};
